module.exports = __webpack_public_path__ + "static/img/nanjing.036e350.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/nanjing.png
// module id = zREu
// module chunks = 1